// HeadlessReportScreen.jsx
//
// Minimal visible status UI for the headless report routes. The
// machine-readable JSON is exposed separately by HeadlessReportController
// (window.__REPORT_STATUS__ and the #report-status DOM node); this component
// is only for humans who happen to open the URL in a normal tab.

const LABELS = {
  pending: "Starting…",
  authenticating: "Verifying access…",
  "loading-design": "Loading design…",
  "loading-model": "Building model…",
  "computing-irradiance": "Computing irradiance…",
  generating: "Generating report…",
  done: "Done.",
  error: "Failed.",
};

const HeadlessReportScreen = ({ reportType, status }) => {
  const phase = status?.phase || "pending";
  const isError = phase === "error";
  const isDone = phase === "done";
  const progress = Math.max(0, Math.min(100, status?.progress || 0));

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: "#0e1116",
        color: "#e6e6e6",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div style={{ fontSize: 14, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}>
        {reportType} report
      </div>
      <div style={{ fontSize: 20, fontWeight: 600 }}>
        {LABELS[phase] || phase}
      </div>
      {!isError && !isDone && (
        <div style={{ width: 280, height: 6, borderRadius: 3, background: "#22262e" }}>
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              borderRadius: 3,
              background: "#4c8bf5",
              transition: "width 0.3s ease",
            }}
          />
        </div>
      )}
      {status?.message && (
        <div style={{ fontSize: 13, opacity: 0.6, maxWidth: 360, textAlign: "center" }}>
          {status.message}
        </div>
      )}
      {isError && status?.reason && (
        <div style={{ fontSize: 12, color: "#ff6b6b" }}>code: {status.reason}</div>
      )}
    </div>
  );
};

export default HeadlessReportScreen;
